import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { EobPaymentDepositEventProps } from '../../model'
import { EventNotes, FieldsGrid } from '../shared'

export function EobPaymentDepositEvent({
  event,
  searchQuery,
}: {
  event: EobPaymentDepositEventProps
  searchQuery: string
}) {
  return (
    <>
      <div className="flex flex-col gap-0.5 py-[3px]">
        <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
        {event.fields ? (
          <FieldsGrid
            fields={event.fields}
            searchQuery={searchQuery}
            userRole={event.userRole}
          />
        ) : null}
      </div>
      {event.notes && event.userRole === 'person' && (
        <EventNotes
          notes={event.notes}
          searchQuery={searchQuery}
        />
      )}
    </>
  )
}
